import { useState } from "react";

import { buttonTheme } from "@components/button/button-constants";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import useUserComboboxQuery from "@components/user-combobox/use-user-combobox-query";
import UserCombobox from "@components/user-combobox/user-combobox";
import { UserComboboxOption } from "@components/user-combobox/user-combobox-list";
import { classNames } from "@helpers/css";

const GoalParticipantsUserPicker = ({
  onSelectUser,
  canChange = true,
  buttonText = "Add participant",
  excludeIds = [],
}: {
  goal: {
    id: number;
  };
  onSelectUser: (user: null | UserComboboxOption) => void;
  canChange: boolean;
  buttonText?: string;
  excludeIds?: number[];
}) => {
  const [canLoadData, setCanLoadData] = useState(false);
  const { loading, options, query, setQuery } = useUserComboboxQuery({
    queryOptions: {
      skip: !canLoadData,
    },
    excludeUserIds: excludeIds,
  });

  const handleChangeAssignee = (option: UserComboboxOption) => {
    onSelectUser(option);
  };

  const handleClearAssignee = () => {
    onSelectUser(null);
  };

  const handlePreloadData = () => {
    setCanLoadData(true);
  };

  const selectedClassName = classNames(
    "text-base flex items-center gap-1",
    "text-gray-400 hover:text-gray-600",
    "font-semibold text-gray-800",
  );

  const filteredOptions = options.filter((option) => {
    return !excludeIds.includes(option.id as number);
  });

  return canChange ? (
    <UserCombobox
      aria-label="Goal participants people dropdown"
      loading={loading}
      query={query}
      value={null}
      options={filteredOptions}
      onChangeValue={handleChangeAssignee}
      onChangeQuery={setQuery}
      onClickButton={handlePreloadData}
      onClearValue={handleClearAssignee}
    >
      <UserCombobox.Button theme={buttonTheme.text} leftNegativeMargin>
        <TopicflowIcon type="plus" className="h-4 w-4 text-gray-700 shrink-0" />
        {buttonText}
      </UserCombobox.Button>
    </UserCombobox>
  ) : (
    <span className={classNames(selectedClassName, "hover:bg-white")}>
      Add an owner
    </span>
  );
};

export default GoalParticipantsUserPicker;
